module.exports=[
  {
    "author": "Daisy F.",
    "avatar": "https://img.peerspace.com/image/upload/v1725383524/yvn1voy5ttkbt9isfrhk.png",
    "testimonial": "My guests were blown away by the presentation and taste of the food at our fundraising brunch. The  beautiful charcuterie board was the highlight of the party! Highly recommend!"
  },
  {
    "author": "Jeff A.",
    "avatar": "https://img.peerspace.com/image/upload/v1725383524/hu8lhaw2215upufooz24.png",
    "testimonial": "The catering offered a great variety of sandwiches, but it was the desserts—brownies, cakes, cookies, and macarons—that had me going back several times. So good."
  },
  {
    "author": "Jesse L.",
    "avatar": "https://img.peerspace.com/image/upload/v1725383524/2uso0yetaebkmwbcipm6.png",
    "testimonial": "The food was exceptional, and the delivery was seamless, arriving promptly and on time, even in Santa Monica during rush hour. My guests were impressed and delighted."
  }
]
